export enum SchemaFormat {
	Apps = 'integratedApps',
	Boolean = 'boolean',
	BooleanToggle = 'booleanToggle',
	BooleanToggleInverse = 'booleanToggleInverse',
	Checkmark = 'checkmark',
	Code = 'code',
	Date = 'date',
	DateTime = 'datetime',
	Definition = 'definition',
	Description = 'description',
	Enum = 'enum',
	HelpText = 'helptext',
	LookAheadSalesforceUser = 'lookAheadSalesforceUser',
	ManagedPackage = 'managedPackage',
	None = 'none',
	Notes = 'notes',
	Object = 'object',
	Owner = 'owner',
	PageLayouts = 'pageLayoutFilter',
	PermissionSources = 'permissionSource',
	PopulationPercentage = 'populationPercentage',
	Primary = 'primary',
	PrimaryInternal = 'primaryInternal',
	Profiles = 'profileFilter',
	ReferenceCount = 'referenceCount',
	SalesforceUser = 'salesforceUser',
	Stakeholder = 'stakeholder',
	Tags = 'tags',
	Text = 'text',
	Time = 'time'
}

export enum AdvancedSchemaFormat {
	SetupAuditTrail = 'SetupAuditTrail',
}
